import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';

import FilterContent from './FilterContent';
import { FilterButton, FilterComponentWrapper, FilterTitle } from './styled';
import { DEFAULT_ALERT_SCORES } from './constants';

import { map } from '../../../../util/lodashlike';
const FilterOption = ({ onChangeAction, optedFilterOption }) => {
  const [visible, setVisible] = useState(false);
  const [sourceIds, setSourceIds] = useState(optedFilterOption.sourceIds);

  const handleVisibleChange = (visibleStatus) => {
    if (!visibleStatus) {
      setSourceIds(optedFilterOption.sourceIds);
    }
    setVisible(visibleStatus);
  };
  const handleSourceSelection = (selectedSourceIds) =>
    setSourceIds(selectedSourceIds);

  const handleOnClear = () => {
    const resetSourceIds = map(DEFAULT_ALERT_SCORES, 'id');
    setVisible(false);
    setSourceIds(resetSourceIds);
    onChangeAction?.(resetSourceIds);
  };

  const handleOnApply = () => {
    setVisible(false);
    onChangeAction?.(sourceIds);
  };

  return (
    <FilterComponentWrapper>
      <FilterTitle>Filter</FilterTitle>
      <Popover
        placement="bottom"
        content={
          <FilterContent
            onVisibleChange={handleVisibleChange}
            onSourceSelection={handleSourceSelection}
            selectedSourceIds={sourceIds}
            onClear={handleOnClear}
            onApply={handleOnApply}
          />
        }
        trigger="click"
        visible={visible}
        onVisibleChange={handleVisibleChange}>
        <FilterButton onClick={() => handleVisibleChange(!visible)}>
          <i className="fa fa-filter"></i>
        </FilterButton>
      </Popover>
    </FilterComponentWrapper>
  );
};

FilterOption.propTypes = {
  onChangeAction: PropTypes.func,
  optedFilterOption: PropTypes.object
};

export default FilterOption;
